import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Divider, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.DividerTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.DividerTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.DividerTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.DividerTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.DividerTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.DividerTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.DividerTypeConst.PLACEHOLDER),
        align: _ctx.getCatalogValue(_ctx.DividerTypeConst.ALIGN),
        layout: _ctx.getCatalogValue(_ctx.DividerTypeConst.LAYOUT),
        type: _ctx.getCatalogValue(_ctx.DividerTypeConst.TYPE),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "align", "layout", "type", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.DividerTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}